import React from "react";
import { ShelterBedMetric } from "./ShelterBedMetric";

export const ShelterTotalBedsMetric = ({ data }: any) => (
  <ShelterBedMetric
    data={data}
    title="Total Beds"
    subtitle=""
    tooltip="Every bed in service. Occupied + Reserved + Vacant always adds up to this."
    field="total_beds"
  />
);
